import React from 'react'
import { points } from '../lib/format'

// Shows a week's optimal lineup. Players who arrive in the trade are marked so
// it's obvious where the change actually landed.
export default function LineupTable({ lineup, total, highlightIds = [], label }) {
  const highlight = new Set(highlightIds)

  return (
    <div>
      <div className="mb-2 flex items-baseline justify-between">
        <h4 className="text-xs font-semibold uppercase tracking-wide text-slate-400">
          {label}
        </h4>
        <span className="text-sm font-semibold tabular-nums text-slate-100">
          {points(total)}
        </span>
      </div>

      <table className="w-full text-sm">
        <tbody>
          {(lineup || []).map((entry, index) => (
            <tr
              key={`${entry.slot}-${entry.player_id}-${index}`}
              className={
                highlight.has(entry.player_id)
                  ? 'bg-emerald-950/40'
                  : undefined
              }
            >
              <td className="w-16 py-1 pr-2 text-xs font-medium text-slate-400">
                {entry.slot}
              </td>
              <td className="py-1 pr-2 text-slate-200">
                {entry.name}
                <span className="ml-1.5 text-xs text-slate-500">
                  {entry.position}
                  {entry.team ? ` · ${entry.team}` : ''}
                </span>
              </td>
              <td className="w-14 py-1 text-right tabular-nums text-slate-300">
                {points(entry.points)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
